/* djimx-swipe.js — arrastre/deslizamiento del banner (hero) con efecto de slide y BUCLE infinito
   (del último al primero y viceversa, igual que el autoplay).

   ⚠️ iOS: NO usamos Pointer Events ni setPointerCapture. En iOS Safari, sobre un scroller,
   los Pointer Events se cancelan (pointercancel) en cuanto el navegador cree que es un scroll,
   y como capturábamos tarde el arrastre no llegaba a engancharse → "el banner no cambiaba en iOS".
   Aquí usamos Touch events (fiables en iOS, con captura implícita al target del touchstart) para
   móvil y Mouse events para escritorio. Sólo hacemos preventDefault cuando el gesto es claramente
   HORIZONTAL y supera el umbral; así:
     · un toque simple sobre un enlace/formulario navega/enfoca de forma NATIVA (no capturamos),
     · un desliz vertical deja el scroll vertical nativo de la página intacto,
     · un arrastre horizontal lo controlamos nosotros (scrollLeft por-frame).

   Convive con slider.js (flechas/puntos/autoplay). El CSS del sitio pone
   `scroll-snap-type: x mandatory !important` que atrapa el scroll programático → lo desactivamos
   con setProperty(...,'important'). Los controles (flechas/puntos) y los controles de formulario
   (input/button/…) no inician arrastre, para que sus clicks/focus funcionen. */
(function () {
  var CONTROLS = '.pf-slider-prev, .pf-slider-next, .pf-slider-nav, input, textarea, select, button, label, [contenteditable]';
  var THRESH = 8;   /* px para decidir arrastre vs toque */

  function slideWidth(el) {
    return (el.firstElementChild ? el.firstElementChild.getBoundingClientRect().width : 0) || el.clientWidth || 1;
  }
  function slideCount(el) {
    var w = slideWidth(el);
    return Math.max(1, Math.round(el.scrollWidth / w));
  }
  function animateTo(el, left, done) {
    if (el.__djimxAnim) { cancelAnimationFrame(el.__djimxAnim); el.__djimxAnim = null; }
    if (el.__pfAnim) { cancelAnimationFrame(el.__pfAnim); el.__pfAnim = null; }  /* no pelear con slider.js */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.scrollLeft = left; if (done) done(); return; }
    var start = el.scrollLeft, dist = left - start, t0 = performance.now(), dur = 380;
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    (function tick(now) {
      var p = Math.min((now - t0) / dur, 1);
      el.scrollLeft = start + dist * ease(p);
      if (p < 1) el.__djimxAnim = requestAnimationFrame(tick);
      else { el.__djimxAnim = null; if (done) done(); }
    })(t0);
  }

  function bind(el) {
    if (el.__djimxSwipe) return;
    el.__djimxSwipe = true;
    el.style.touchAction = 'pan-y';
    el.style.setProperty('scroll-snap-type', 'none', 'important');  /* vence el snap !important del sitio */

    var startX = 0, startY = 0, ss = 0, sw = 0, moved = 0;
    var active = false, decided = false, dragging = false, lastTouch = 0;

    function grab() { el.style.setProperty('scroll-behavior', 'auto', 'important'); }
    function restore() { el.style.removeProperty('scroll-behavior'); }

    function begin(x, y, target) {
      moved = 0;  /* SIEMPRE al inicio del toque: si no, un toque sobre un control (botón/input) tras un
                     arrastre conservaba el `moved` grande anterior y el click-guard de captura anulaba el
                     click → en móvil "no se podía pulsar suscribir" tras deslizar el banner. */
      if (target && target.closest && target.closest(CONTROLS)) return false;  /* flechas/puntos/form → no arrastrar */
      startX = x; startY = y; ss = el.scrollLeft; sw = slideWidth(el);
      active = true; decided = false; dragging = false;
      if (el.__djimxAnim) { cancelAnimationFrame(el.__djimxAnim); el.__djimxAnim = null; }
      if (el.__pfAnim) { cancelAnimationFrame(el.__pfAnim); el.__pfAnim = null; }
      return true;
    }
    function move(x, y, ev) {
      if (!active) return;
      var dx = x - startX, dy = y - startY;
      if (!decided) {
        if (Math.abs(dx) < THRESH && Math.abs(dy) < THRESH) return;
        decided = true;
        if (Math.abs(dx) > Math.abs(dy)) { dragging = true; grab(); }   /* horizontal → arrastre */
        else { active = false; return; }                                /* vertical → scroll nativo de la página */
      }
      if (dragging) {
        if (ev && ev.cancelable) ev.preventDefault();   /* sólo aquí bloqueamos lo nativo */
        moved = Math.max(moved, Math.abs(dx));
        el.scrollLeft = ss - dx;                          /* sigue el dedo (topa en los extremos) */
      }
    }
    function finish(x) {
      if (!active) return;
      active = false;
      if (!dragging) {
        /* fue un toque, no un arrastre → el click/focus nativo hace su trabajo (enlace/form).
           Pero si al empezar el toque se canceló una animación (autoplay) a medias, encaja a la
           diapositiva más cercana para no quedar "a mitad". */
        var near = Math.round(el.scrollLeft / sw) * sw;
        if (Math.abs(el.scrollLeft - near) > 1) { grab(); animateTo(el, near, restore); }
        return;
      }
      var dx = (x == null ? 0 : x - startX);
      var count = slideCount(el);
      var cur = Math.round(ss / sw);
      var target = cur;
      if (Math.abs(dx) > 40) { target = dx < 0 ? cur + 1 : cur - 1; }
      if (target < 0) target = count - 1;               /* del primero hacia atrás -> último */
      else if (target > count - 1) target = 0;           /* del último hacia adelante -> primero */
      animateTo(el, target * sw, restore);
    }

    /* --- Touch (móvil / iOS): captura implícita al target del touchstart, sin setPointerCapture --- */
    el.addEventListener('touchstart', function (e) {
      lastTouch = Date.now();
      if (e.touches.length !== 1) { active = false; return; }
      var t = e.touches[0];
      begin(t.clientX, t.clientY, e.target);
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!active) return;
      var t = e.touches[0];
      move(t.clientX, t.clientY, e);   /* preventDefault sólo si es arrastre horizontal (listener no-pasivo) */
    }, { passive: false });
    el.addEventListener('touchend', function (e) {
      lastTouch = Date.now();
      var t = e.changedTouches && e.changedTouches[0];
      finish(t ? t.clientX : null);
    }, { passive: true });
    el.addEventListener('touchcancel', function () { active = false; dragging = false; }, { passive: true });

    /* --- Mouse (escritorio): move/up en document para no perder el arrastre al salir del elemento --- */
    function onMouseMove(e) { move(e.clientX, e.clientY, e); }
    function onMouseUp(e) {
      finish(e.clientX);
      document.removeEventListener('mousemove', onMouseMove, true);
      document.removeEventListener('mouseup', onMouseUp, true);
    }
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (Date.now() - lastTouch < 600) return;   /* ignora el mouse sintético que iOS/Android emite tras un touch */
      if (!begin(e.clientX, e.clientY, e.target)) return;
      document.addEventListener('mousemove', onMouseMove, true);
      document.addEventListener('mouseup', onMouseUp, true);
    });

    /* tras un arrastre real, no dejes que el click navegue la diapositiva; PERO nunca bloquees los
       controles (botón/input/label/enlace-de-control): si no, un toque sobre "suscribir" tras deslizar
       el banner quedaba anulado por un `moved` residual → "no se podía pulsar suscribir" en móvil. */
    el.addEventListener('click', function (e) {
      if (moved > THRESH && !(e.target && e.target.closest && e.target.closest(CONTROLS))) {
        e.preventDefault(); e.stopPropagation();
      }
    }, true);
  }

  function init() { document.querySelectorAll('.pf-slider.scrollfix').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
